import { render, staticRenderFns } from "./manual_rating_judge_table_header.vue?vue&type=template&id=5108d9a2&scoped=true"
import script from "./manual_rating_judge_table_header.vue?vue&type=script&lang=js"
export * from "./manual_rating_judge_table_header.vue?vue&type=script&lang=js"
import style0 from "./manual_rating_judge_table_header.vue?vue&type=style&index=0&id=5108d9a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108d9a2",
  null
  
)

export default component.exports